<template>
<div class="chapter">
<div class="inner_page">
<div class="plm_hd">Contents</div>
<div class="sgc-toc-level-1">
<a href="#/Text/NSBT_BibTheol_serpref">Series preface</a>
</div>
<div class="sgc-toc-level-1">
<a href="#/Text/NSBT_BibTheol_autpref">Authors’ preface</a>
</div>
<div class="sgc-toc-level-1">
<a href="#/Text/NSBT_BibTheol_abbrev">Abbreviations</a>
</div>
<div class="sgc-toc-level-1s">
<a href="#/Text/NSBT_BibTheol_ch01"><span class="bold2">1 Introduction</span></a>
</div>
<div class="sgc-toc-level-2">
<a href="#/Text/NSBT_BibTheol_ch01#sigil_toc_id_2">Our idea: exploring the exposed iceberg</a>
</div>
<div class="sgc-toc-level-2">
<a href="#/Text/NSBT_BibTheol_ch01#sigil_toc_id_3">Our criteria: New Testament summaries of Israel’s story</a>
</div>
<div class="sgc-toc-level-2">
<a href="#/Text/NSBT_BibTheol_ch01#sigil_toc_id_4">Our method: context, content and contribution</a>
</div>
<div class="sgc-toc-level-1s">
<a href="#/Text/NSBT_BibTheol_ch02"><span class="bold2">2 Matthew and Israel’s continuing story</span></a>
</div>
<div class="sgc-toc-level-2">
<a href="#/Text/NSBT_BibTheol_ch02#sigil_toc_id_6">The context of Matthew’s genealogy</a>
</div>
<div class="sgc-toc-level-2">
<a href="#/Text/NSBT_BibTheol_ch02#sigil_toc_id_7">The content of Matthew’s genealogy (Matt. 1:1–17)</a>
</div>
<div class="sgc-toc-level-2">
<a href="#/Text/NSBT_BibTheol_ch02#sigil_toc_id_8">The context of the parable of the tenants</a>
</div>
<div class="sgc-toc-level-2">
<a href="#/Text/NSBT_BibTheol_ch02#sigil_toc_id_9">The content of the parable of the tenants (Matt. 21:33–46)</a>
</div>
<div class="sgc-toc-level-2">
<a href="#/Text/NSBT_BibTheol_ch02#sigil_toc_id_10">Reading Israel’s story with Matthew</a>
</div>
<div class="sgc-toc-level-2">
<a href="#/Text/NSBT_BibTheol_ch02#sigil_toc_id_11">The great commission and Israel’s story in Matthew’s Gospel</a>
</div>
<div class="sgc-toc-level-2">
<a href="#/Text/NSBT_BibTheol_ch02#sigil_toc_id_12">The contribution of Matthew’s summaries</a>
</div>
<div class="sgc-toc-level-2">
<a href="#/Text/NSBT_BibTheol_ch02#sigil_toc_id_13">Conclusion</a>
</div>
<div class="sgc-toc-level-1s">
<span href="#/Text/NSBT_BibTheol_ch03" title="Link target outside of Sample"><span class="bold2">3 Luke, Acts and the climax of Israel’s story</span></span>
</div>
<div class="sgc-toc-level-2">
<span href="#/Text/NSBT_BibTheol_ch03#sigil_toc_id_15" title="Link target outside of Sample">The context: the Gospel of Luke</span>
</div>
<div class="sgc-toc-level-2">
<span href="#/Text/NSBT_BibTheol_ch03#sigil_toc_id_16" title="Link target outside of Sample">The context: Acts</span>
</div>
<div class="sgc-toc-level-2">
<span href="#/Text/NSBT_BibTheol_ch03#sigil_toc_id_17" title="Link target outside of Sample">The context of Stephen’s speech</span>
</div>
<div class="sgc-toc-level-2">
<span href="#/Text/NSBT_BibTheol_ch03#sigil_toc_id_18" title="Link target outside of Sample">The content of Stephen’s speech (Acts 7)</span>
</div>
<div class="sgc-toc-level-2">
<span href="#/Text/NSBT_BibTheol_ch03#sigil_toc_id_19" title="Link target outside of Sample">Summary of Stephen’s speech</span>
</div>
<div class="sgc-toc-level-2">
<span href="#/Text/NSBT_BibTheol_ch03#sigil_toc_id_20" title="Link target outside of Sample">The context of Paul’s sermon</span>
</div>
<div class="sgc-toc-level-2">
<span href="#/Text/NSBT_BibTheol_ch03#sigil_toc_id_21" title="Link target outside of Sample">The content of Paul’s sermon (Acts 13:16–41)</span>
</div>
<div class="sgc-toc-level-2">
<span href="#/Text/NSBT_BibTheol_ch03#sigil_toc_id_22" title="Link target outside of Sample">Summary of Paul’s sermon</span>
</div>
<div class="sgc-toc-level-2">
<span href="#/Text/NSBT_BibTheol_ch03#sigil_toc_id_23" title="Link target outside of Sample">The contribution of Luke’s summaries</span>
</div>
<div class="sgc-toc-level-2">
<span href="#/Text/NSBT_BibTheol_ch03#sigil_toc_id_24" title="Link target outside of Sample">Conclusion</span>
</div>
<div class="sgc-toc-level-1s">
<span href="#/Text/NSBT_BibTheol_ch04" title="Link target outside of Sample"><span class="bold2">4 Galatians and Israel’s law</span></span>
</div>
<div class="sgc-toc-level-2">
<span href="#/Text/NSBT_BibTheol_ch04#sigil_toc_id_26" title="Link target outside of Sample">The context of Paul’s summary</span>
</div>
<div class="sgc-toc-level-2">
<span href="#/Text/NSBT_BibTheol_ch04#sigil_toc_id_27" title="Link target outside of Sample">The content of Paul’s summary (Gal. 3 – 4)</span>
</div>
<div class="sgc-toc-level-2">
<span href="#/Text/NSBT_BibTheol_ch04#sigil_toc_id_28" title="Link target outside of Sample">The contribution of Paul’s summary</span>
</div>
<div class="sgc-toc-level-2">
<span href="#/Text/NSBT_BibTheol_ch04#sigil_toc_id_29" title="Link target outside of Sample">Conclusion</span>
</div>
<div class="sgc-toc-level-1s">
<span href="#/Text/NSBT_BibTheol_ch05" title="Link target outside of Sample"><span class="bold2">5 Romans and Israel’s identity</span></span>
</div>
<div class="sgc-toc-level-2">
<span href="#/Text/NSBT_BibTheol_ch05#sigil_toc_id_31" title="Link target outside of Sample">The context of Paul’s summary</span>
</div>
<div class="sgc-toc-level-2">
<span href="#/Text/NSBT_BibTheol_ch05#sigil_toc_id_32" title="Link target outside of Sample">The content of Paul’s summary (Rom. 9 – 11)</span>
</div>
<div class="sgc-toc-level-2">
<span href="#/Text/NSBT_BibTheol_ch05#sigil_toc_id_33" title="Link target outside of Sample">The contribution of Paul’s summary</span>
</div>
<div class="sgc-toc-level-2">
<span href="#/Text/NSBT_BibTheol_ch05#sigil_toc_id_34" title="Link target outside of Sample">Conclusion</span>
</div>
<div class="sgc-toc-level-1s">
<span href="#/Text/NSBT_BibTheol_ch06" title="Link target outside of Sample"><span class="bold2">6 Hebrews and Israel’s inheritance</span></span>
</div>
<div class="sgc-toc-level-2">
<span href="#/Text/NSBT_BibTheol_ch06#sigil_toc_id_36" title="Link target outside of Sample">The context of Hebrews’s summary</span>
</div>
<div class="sgc-toc-level-2">
<span href="#/Text/NSBT_BibTheol_ch06#sigil_toc_id_37" title="Link target outside of Sample">The content of Hebrews’s summary (Heb. 11)</span>
</div>
<div class="sgc-toc-level-2">
<span href="#/Text/NSBT_BibTheol_ch06#sigil_toc_id_38" title="Link target outside of Sample">The contribution of Hebrews’s summary</span>
</div>
<div class="sgc-toc-level-2">
<span href="#/Text/NSBT_BibTheol_ch06#sigil_toc_id_39" title="Link target outside of Sample">Conclusion</span>
</div>
<div class="sgc-toc-level-1s">
<span href="#/Text/NSBT_BibTheol_ch07" title="Link target outside of Sample"><span class="bold2">7 Conclusion: a biblical-theological rule of faith</span></span>
</div>
<div class="sgc-toc-level-2">
<span href="#/Text/NSBT_BibTheol_ch07#sigil_toc_id_41" title="Link target outside of Sample">Summary of the contributions</span>
</div>
<div class="sgc-toc-level-2">
<span href="#/Text/NSBT_BibTheol_ch07#sigil_toc_id_42" title="Link target outside of Sample">Biblical-theological prescriptions</span>
</div>
<div class="sgc-toc-level-2">
<span href="#/Text/NSBT_BibTheol_ch07#sigil_toc_id_43" title="Link target outside of Sample">Israel’s story and our stories</span>
</div>
<div class="sgc-toc-level-1s">
<span href="#/Text/NSBT_BibTheol_bibliog" title="Link target outside of Sample">Bibliography</span>
</div>
<div class="sgc-toc-level-1">
<span href="#/Text/NSBT_BibTheol_idxaut" title="Link target outside of Sample">Search names for authors</span>
</div>
<div class="sgc-toc-level-1">
<span href="#/Text/NSBT_BibTheol_idxscrip" title="Link target outside of Sample">Search items for Scripture references</span>
</div>
<div class="sgc-toc-level-1">
<span href="#/Text/NSBT_BibTheol_sertit" title="Link target outside of Sample">Titles in this series</span>
</div>
<div class="sgc-toc-level-1">
<span href="#/Text/NSBT_BibTheol_notes" title="Link target outside of Sample">Notes</span>
</div>
<div class="sgc-toc-level-1">
<span href="#/Text/NSBT_ata" title="Link target outside of Sample">About the Author</span>
</div>
<div class="sgc-toc-level-1">
<span href="#/Text/NSBT_moreIVP" title="Link target outside of Sample">More Titles from InterVarsity Press</span>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// NSBT_BibTheol_contents.vue?734b7f68